document.addEventListener('DOMContentLoaded', () => {
    const addressInput = document.getElementById('address');
    const resultsContainer = document.getElementById('autocomplete-results');
    let debounceTimer;

    if (!addressInput || !resultsContainer) return;

    // Fetch from Nominatim API
    const fetchAddresses = async (query) => {
        try {
            // US country codes focus, limit to 5 results
            const response = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=5&countrycodes=us`);
            
            if (!response.ok) throw new Error('Network response was not ok');
            
            const data = await response.json();
            renderResults(data);
        } catch (error) {
            console.error('Error fetching addresses:', error);
            // On error, just hide results and let them type manually
            hideResults();
        }
    };

    // Render results in dropdown
    const renderResults = (results) => {
        resultsContainer.innerHTML = '';
        
        if (results.length === 0) {
            hideResults();
            return;
        }

        results.forEach(result => {
            const div = document.createElement('div');
            div.className = 'result-item';
            div.textContent = result.display_name;
            
            // On click, set value and hide
            div.addEventListener('click', () => {
                addressInput.value = result.display_name;
                addressInput.classList.remove('is-invalid');
                addressInput.classList.add('is-valid');
                hideResults();
                
                // Trigger change event for validation
                const event = new Event('change');
                addressInput.dispatchEvent(event);
            });
            
            resultsContainer.appendChild(div);
        });

        resultsContainer.classList.add('show');
    };

    const hideResults = () => {
        resultsContainer.classList.remove('show');
        resultsContainer.innerHTML = '';
    };

    // Input event with debounce
    addressInput.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        
        clearTimeout(debounceTimer);
        
        if (query.length < 5) {
            hideResults();
            return;
        }

        debounceTimer = setTimeout(() => {
            fetchAddresses(query);
        }, 300); // 300ms debounce
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        if (e.target !== addressInput && e.target !== resultsContainer) {
            hideResults();
        }
    });
});
